import React, { useState, useCallback } from 'react';
import './GuestList.scss';
import AvatarCard from './AvatarCard/AvatarCard';
import RSVPModal from './RSVPModal/RSVPModal';
import RSVPGuestsModal from './RSVPGuestsModal/RSVPGuestsModal';

/**
 * @param {{ id: string; imageUrl?: string; alt: string; isFavorite?: boolean; isVerified?: boolean }[]} guests
 */
const GuestListRes = ({ guests, hide, finish }) => {
  if(hide) return null;
  const [selectedGuest, setSelectedGuest] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShowMoreOpen, setIsShowMoreOpen] = useState(false);
  
  const hasGuests = finish;

  const openRSVPModal = (guest) => {
    setSelectedGuest(guest);
    setIsModalOpen(true);
  };

  const openRSVPMoreModal = () => {
    setIsShowMoreOpen(true);
  };//redeploy

  const closeRSVPModal = () => {
    setIsModalOpen(false);
    setIsShowMoreOpen(false);
    setSelectedGuest(null);
  };

  const scrollToTickets = useCallback(() => {
    const ticketSection = document.getElementById('ticket-purchase');
    if (ticketSection) ticketSection.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const handleRSVP = () => {
    closeRSVPModal();
    scrollToTickets();
  };

  // If guests not loaded yet, show skeletons only
  if (!hasGuests) {
    return (
      <div className="guestlist-container">
        <h2 className="guestlist-title">Guestlist</h2>
        <div className="guestlist-grid">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="avatar-skeleton" />
          ))}
        </div>
      </div>
    );
  }
  if (!guests || guests.length === 0) {
    return (
      <div className="attendees-row">
      
      </div>
    );
  }
  return (
    <div className="guestlist-container">
      <h2 className="guestlist-title">Guestlist</h2>
      <div className="guestlist-grid">
        {guests.map((guest) => (
          <AvatarCard
            key={guest.uid}
            uid={guest.uid}
            imageUrl={guest.imageUrl || ''}
            name={guest.name}
            isFavorite={guest.isFavorite}
            isVerified={guest.isVerified}
            onClick={() => openRSVPModal(guest)}
          />
        ))}
      </div>

      <button
        className="guestlist-show-more"
        onClick={openRSVPMoreModal}
      >
        Show More
      </button>

      {selectedGuest && (
        <RSVPModal
          isOpen={isModalOpen}
          user={selectedGuest}
          onClose={closeRSVPModal}
          onRSVP={handleRSVP}
        />
      )}

      {isShowMoreOpen && (
        <RSVPGuestsModal
          isOpen={isShowMoreOpen}
          attendees={guests}
          onClose={closeRSVPModal}
          onRSVP={handleRSVP}
        />
      )}
    </div>
  );
};

export default GuestListRes;
